import React, { useEffect, useState } from 'react'
import { Input, Modal, Radio } from 'antd'
import { Icon } from '@iconify/react'

import styles from './SaveWorkloadReportModal.module.css'

const SaveWorkloadReportModal = ({
    open,
    defaultName = '',
    confirmLoading = false,
    onCancel,
    onSubmit,
}) => {
    const [name, setName] = useState(defaultName)
    const [visibility, setVisibility] = useState('workspace')
    const [alsoDownload, setAlsoDownload] = useState(false)

    useEffect(() => {
        if (!open) return
        setName(defaultName)
        setVisibility('workspace')
        setAlsoDownload(false)
    }, [open, defaultName])

    const trimmed = name.trim()
    const canSubmit =
        Boolean(trimmed) && trimmed.length <= 200 && !confirmLoading

    const handleSubmit = () => {
        if (!canSubmit) return
        onSubmit?.({
            name: trimmed,
            visibility,
            alsoDownload,
        })
    }

    const handleClose = () => {
        if (confirmLoading) return
        onCancel?.()
    }

    return (
        <Modal
            className={styles.modal}
            title={
                <div className={styles.header}>
                    <h2 className={styles.modalTitle}>Save report</h2>
                </div>
            }
            open={open}
            onCancel={handleClose}
            footer={null}
            width={460}
            centered
            destroyOnHidden
            maskClosable={!confirmLoading}
            closable={!confirmLoading}
        >
            <div className={styles.body}>
                <div className={styles.field}>
                    <label className={styles.label} htmlFor="save-report-name">
                        Report name
                    </label>
                    <Input
                        id="save-report-name"
                        value={name}
                        maxLength={200}
                        allowClear
                        autoFocus
                        placeholder="e.g. Workload · 11 Aug 2026"
                        disabled={confirmLoading}
                        onChange={(e) => setName(e.target.value)}
                        onPressEnter={handleSubmit}
                    />
                </div>

                <div className={styles.field}>
                    <div className={styles.label}>Visibility</div>
                    <Radio.Group
                        className={styles.visibilityGroup}
                        value={visibility}
                        disabled={confirmLoading}
                        onChange={(e) => setVisibility(e.target.value)}
                        optionType="button"
                        buttonStyle="solid"
                        options={[
                            { label: 'Workspace', value: 'workspace' },
                            { label: 'Private', value: 'private' },
                        ]}
                    />
                </div>

                <label className={styles.checkRow}>
                    <input
                        type="checkbox"
                        checked={alsoDownload}
                        disabled={confirmLoading}
                        onChange={(e) => setAlsoDownload(e.target.checked)}
                    />
                    <span>Also download PDF after saving</span>
                </label>

                <div className={styles.modalFooter}>
                    <div className={styles.formActions}>
                        <button
                            type="button"
                            onClick={handleClose}
                            disabled={confirmLoading}
                            className={styles.cancelButton}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            disabled={!canSubmit}
                            onClick={handleSubmit}
                            className={`${styles.submitButton} ${
                                confirmLoading
                                    ? styles.submitButtonDisabled
                                    : ''
                            }`}
                        >
                            {confirmLoading ? (
                                <>
                                    <Icon
                                        icon="line-md:loading-loop"
                                        width={16}
                                        height={16}
                                    />
                                    Saving…
                                </>
                            ) : alsoDownload ? (
                                'Save & download'
                            ) : (
                                'Save report'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default SaveWorkloadReportModal
